import { render, staticRenderFns } from "./CheckBoxInput.vue?vue&type=template&id=3f857c81"
import script from "./CheckBoxInput.vue?vue&type=script&lang=js"
export * from "./CheckBoxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports